import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { NavLink, useSearchParams } from "react-router-dom";
import { useAccount, useAccountID } from "../store/account";
import { useCurrentPlan } from "../store/currentPlan";
import { usePlanUpgrades } from "../store/plan-upgrades";
import { usePlans } from "../store/plans";
import { addToast } from "../store/ui";
import Upgrade from "./Upgrade";

export default function UpgradeAccount() {
    const dispatch = useDispatch();
    const { data: account } = useAccount();
    const accountID = useAccountID();
    const { data: currentPlan } = useCurrentPlan(accountID);
    const plans = usePlans().data?.filter(
        plan =>
            currentPlan != null &&
            currentPlan.productID != plan.productID &&
            plan.prices[0].amount > 0
    );
    const { data: upgrades } = usePlanUpgrades();
    const [planQuantity, setPlanQuantity] = useState([]);
    var totalCost = 0;
    if (currentPlan) {
        totalCost = currentPlan.amount;
        if (currentPlan.upgrades && currentPlan.upgrades.length > 0)
            totalCost =
                totalCost +
                currentPlan.upgrades
                    .map(p => p.amount * p.quantity)
                    .reduce((total, a) => total + a);
    }

    const [queryParams, setQueryParams] = useSearchParams();
    const upgradeStatus = queryParams.get("status");
    useEffect(() => {
        if (upgradeStatus == "cancelled") dispatch(addToast("Plan Upgrade Cancelled"));
        else if (upgradeStatus == "complete") dispatch(addToast("Plan Upgrade Complete"));
    }, []);

    const handleQuantityChange = function (productPriceID, quantity) {
        if (!productPriceID) return;

        var newQuantity = [...planQuantity];
        newQuantity[productPriceID] = quantity;
        setPlanQuantity(newQuantity);
    };
    const handlePurchaseClick = function (event) {
        if (!confirm("Purchase")) event.preventDefault();
    };
    if (currentPlan && !planQuantity[currentPlan.productPriceID])
        handleQuantityChange(currentPlan.productPriceID, currentPlan.quantity);

    return (
        <>
            <Helmet>
                <title>Plan Info - Podtrac</title>
            </Helmet>
            <h1>Plan Info</h1>
            {account == null || currentPlan == null ? (
                ""
            ) : (
                <div>
                    <b>Your Current Plan:</b> {currentPlan.name}
                    <br />
                    {currentPlan.upgrades
                        ? currentPlan.upgrades.map(upgrade => (
                              <>
                                  {upgrade.quantity > 1 ? upgrade.quantity : ""} x {upgrade.name}
                                  <br />
                              </>
                          ))
                        : ""}
                    <b>Users:</b> {account.maxUsers}
                    <br />
                    {account.isPaidPlan ? (
                        <>
                            <b>Cost:</b> ${totalCost / 100} per year
                            <br />
                            {currentPlan.stripeCustomerID ? (
                                <>
                                    <a href={`/${accountID}/checkout/customer-portal`}>
                                        Manage Plan Subscription
                                    </a>{" "}
                                    - update payment info
                                    <br />
                                </>
                            ) : (
                                ""
                            )}
                            <b>Auto renews on:</b>{" "}
                            {DateTime.fromISO(currentPlan.endDate, { zone: "utc" }).toLocaleString(
                                DateTime.DATE_FULL
                            )}
                            <br />
                        </>
                    ) : (
                        ""
                    )}
                </div>
            )}

            {!account ? (
                ""
            ) : account.isPaidPlan ? (
                <p>
                    Need more than {account.maxUsers} Users?{" "}
                    <a href="mailto:support@podtrac.com">Contact us</a> to find out how to add
                    additional Users.
                </p>
            ) : (
                account.offerUpgrade && (
                    <p>
                        Upgrade to the Grow Your Show plan to get historical data, multi-user
                        access, Excel exports, and more features.{" "}
                        <NavLink to={`/dashboard/${accountID}/upgrade`}>Learn more</NavLink>.
                    </p>
                )
            )}

            {/* Disable upgrades until the payment flow is ironed out */}
            {true ||
            account == null ||
            currentPlan == null ||
            currentPlan.amount == 0 ||
            upgrades == null ||
            upgrades.length == 0 ? (
                ""
            ) : (
                <div>
                    <h3>More</h3>
                    {upgrades.map(upgrade => (
                        <div key={upgrade.productID}>
                            <div>
                                <b>{upgrade.name}</b>
                            </div>
                            <div>{upgrade.description}</div>
                            {upgrade.prices.map(price => (
                                <form
                                    action={`/${accountID}/checkout/start/${price.productPriceID}`}
                                    method="post"
                                    key={price.productPriceID}
                                >
                                    <select
                                        name="quantity"
                                        onChange={event => {
                                            handleQuantityChange(
                                                price.productPriceID,
                                                event.target.value
                                            );
                                        }}
                                    >
                                        {[1, 2, 3, 4, 5, 6].map(x => (
                                            <option
                                                value={x}
                                                key={x}
                                                selected={planQuantity[price.productPriceID] == x}
                                            >
                                                Add {x}
                                            </option>
                                        ))}
                                    </select>
                                    <button type="submit" onClick={handlePurchaseClick}>
                                        Select for $
                                        {((planQuantity[price.productPriceID] || 1) *
                                            price.amount) /
                                            100}{" "}
                                        per year
                                    </button>
                                </form>
                            ))}
                        </div>
                    ))}
                </div>
            )}

            {account && account.isPaidPlan ? (
                <details>
                    <summary style={{ marginBottom: "1em" }}>
                        <h2 style={{ margin: 0, display: "inline-block", cursor: "pointer" }}>
                            Plan Features
                        </h2>
                    </summary>
                    <Upgrade standAlone={false} />
                </details>
            ) : null}
        </>
    );
}
